import React from 'react'
import { connect } from 'react-redux'
import { fetchEntities } from 'actions/entities';
import EntitiesMenu from 'components/entities/EntitiesMenu';
import { Menu, Segment } from 'semantic-ui-react'
import { NavLink } from 'react-router-dom'
import { getConsultationTypes } from 'selectors/consultation_types'



const mapStateToProps = (state, ownProps) => {
  return {
    entities: getConsultationTypes(state,ownProps),
    entityName: 'consultationType',
    item: (props) => <div>{`${props.consultationType.name}`}</div>,
    loading: state.meta.consultationType.loading,
    error: state.meta.consultationType.error,
    admin: true
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchEntities: () => {
      dispatch(fetchEntities('consultationTypes'))
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EntitiesMenu);
